//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import WorkOpinionDrawer from "./modules/WorkOpinionDrawer";
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import { queryProjectArchtList } from '@/api/api';
export default {
  name: "WorkOpinionList",
  mixins: [JeecgListMixin],
  components: {
    WorkOpinionDrawer: WorkOpinionDrawer
  },
  data: function data() {
    return {
      pagePath: '/om/work/opinion',
      pageTitle: '意见评论',
      // 表头
      columns: [{
        title: '序号',
        dataIndex: '',
        key: 'rowIndex',
        width: 60,
        align: "center",
        customRender: function customRender(t, r, index) {
          return parseInt(index) + 1;
        }
      }, {
        dataIndex: 'originId',
        colName: 'origin_id',
        title: '来源id:评论的是那条数据',
        align: "center",
        sorter: true
      }, {
        dataIndex: 'originKey',
        colName: 'origin_key',
        title: '评论类型：反馈单；任务单等',
        align: "center",
        sorter: true
      }, {
        dataIndex: 'opinion',
        colName: 'opinion',
        title: '具体意见',
        align: "center",
        sorter: true
      }, {
        dataIndex: 'parentId',
        colName: 'parent_id',
        title: '上级意见',
        align: "center",
        sorter: true
      }, {
        title: '操作',
        dataIndex: 'action',
        align: "center",
        width: 120,
        scopedSlots: {
          customRender: 'action'
        }
      }]
    };
  },
  created: function created() {},
  computed: {},
  methods: {}
};